export default __webpack_public_path__ + "static/media/main-hall.6e291e3a.jpg";